import { render, staticRenderFns } from "./SEllipsisTooltip.vue?vue&type=template&id=571c8a39&lang=pug"
import script from "./SEllipsisTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SEllipsisTooltip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports